module.exports = __webpack_public_path__ + "img/error.13a2ef6a.svg";